export default __webpack_public_path__ + "static/media/waouh.5fec4b8d.png";